import React, { useState } from 'react';

import axiosInstance from '../../api/axiosInstance';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { red } from '@mui/material/colors';

import { Stack, Typography } from '@mui/material';

import InvoiceItemsCollapse from './InvoiceItemsCollapse.js';

export default function InvoiceRow({ invoice, accounts }) {
    const [collapseOpen, setCollapseOpen] = React.useState(false);
    // const [isDialogOpen, setDialogOpen] = React.useState(false);

    const VAT_RATES = {
        NOR: '20 %',
        MID: '10 %',
        RED: '5,5 %',
        SPE: '2,1 %',
        NUL: '0 %',
        ND: 'indéterminé',
    };

    // const handleDialogClose = () => setDialogOpen(false);
    // const handleDialogOpen = () => setDialogOpen(true);

    // const handleUpdate = async (updatedEntry) => {
    //     try {
    //         // Mets à jour l'entrée dans la base de données
    //         await axios.put(`http://localhost:8000/api/entries/${updatedEntry.id}/`, updatedEntry);
    //         onUpdate(updatedEntry); // Mets à jour l'état global dans EntryTable
    //     } catch (error) {
    //         console.error("Erreur lors de la mise à jour de la transaction :", error);
    //     } finally {
    //         setDialogOpen(false); // Ferme le dialogue après la mise à jour
    //     }
    // };

    const handleDownloadInvoicePDF = async () => {
        try {
            const response = await axiosInstance.get(`api/invoices/download/${invoice.id}/`, {
                responseType: 'blob',
        });
        // Créez un lien pour télécharger le fichier
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Facture - ${invoice.number}.pdf`); // Nom du fichier
        document.body.appendChild(link);
        link.click();
        link.remove();
        } catch (error) {
            console.error("Erreur lors du téléchargement du PDF.", error);
        }
    };

    return (
        <>
            <TableRow>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setCollapseOpen(!collapseOpen)}
                    >
                        {collapseOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">{new Date(invoice.date).toLocaleDateString('fr-FR', { day: undefined, month: 'long', year: 'numeric' }).replace('.', '')}</TableCell>
                <TableCell align="left">
                    {accounts.find((acc) => acc.id === invoice.account)?.full_name || "Compte introuvable"}
                </TableCell>
                <TableCell>{invoice.number}</TableCell>
                <TableCell align="right">
                    <Typography variant='body1'>{invoice.total_amount.toLocaleString('fr-FR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}</Typography>
                </TableCell>
                <TableCell align='center'>
                    <IconButton onClick={handleDownloadInvoicePDF} aria-label="download" size="small">
                        <FileDownloadIcon fontSize="inherit" />
                    </IconButton>
                </TableCell>
            </TableRow>
            <InvoiceItemsCollapse open={collapseOpen} invoice={invoice} accounts={accounts} />
        </>
    );
};